<template>
    <div class="container-fluid">
        <pickup-modal :show.sync="showPickupModal" :bookings="checkedBookings"></pickup-modal>
        <loading-list-modal :show.sync="showLoadingListModal" :bookings="checkedBookings"></loading-list-modal>
        <label-modal :show.sync="showLabelModal" :booking="labelBooking" v-if="showLabelModal"></label-modal>
        <attach-invoice-modal :show.sync="showInvoiceModal" :booking="invoiceBooking"></attach-invoice-modal>
        <div class="row">
            <heading>{{ $t('booking.menuName') }}
                <template v-slot:actions>
                    <span class="btn btn-outline-primary mx-1" v-if="checkedBookings.length > 0" @click="showLoadingListModal = true">{{ $t('booking.pickupMailLoadingList') }}</span>
                    <span class="btn btn-outline-primary mx-1" v-if="checkedBookings.length > 0" @click="showPickupModal = true">{{ $t('booking.bookPickup') }}</span>
                    <a href="/bookings/return" class="btn btn-outline-primary mx-1" v-if="$root.isAdmin === false">{{ $t('booking.newReturn') }}</a>
                    <a href="/bookings/create" class="btn btn-primary mx-1" v-if="$root.isAdmin === false">{{ $t('booking.new') }}</a>
                </template>
            </heading>
        </div>
        <div class="row" v-if="filters.limitIds.length > 0">
            <div class="col-12 text-center">
                <div class="alert alert-info d-inline-block">
                    {{ $t('booking.filter.warningForPickupFilterApplied') }}<br/>
                    <button class="btn btn-primary mt-2" @click="resetFilters">{{ $t('booking.showAllBookings') }}</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="card col-12">
                <div class="card-body">
                    <div>
                        <div class="row">
                            <div class="col-12">
                                <div class="input-group mb-3">
                                    <input type="text" v-model="filters.query" :placeholder="$t('core.search')" class="form-control" @keydown.enter="search">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-danger" type="button" @click="() => {this.filters.query=''; this.search()}" v-show="filters.query !== ''">{{
                                                $t('core.actions.clear')
                                            }}
                                        </button>
                                        <button class="btn btn-outline-secondary" type="button" @click="search">{{ $t('core.search') }}</button>
                                    </div>
                                </div>

                                <button class="btn btn-link float-right" @click="filterVisible = !filterVisible">{{ $t('booking.filter.filter') }}</button>
                                <b-collapse v-model="filterVisible" style="clear: both;">
                                    <hr class="border-primary"/>
                                    <div class="form-group" v-if="$root.isAdmin === true || $root.isSuperAdmin === true">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="load-address-check" v-model="filters.isNotExported">
                                            <label class="custom-control-label" for="load-address-check">{{ $t('booking.filter.notExported') }}</label>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="only-returns" v-model="filters.onlyReturns">
                                            <label class="custom-control-label" for="only-returns">{{ $t('booking.filter.onlyReturns') }}</label>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="only-pickup" v-model="filters.onlyPickup">
                                            <label class="custom-control-label" for="only-pickup">{{ $t('booking.filter.onlyPickup') }}</label>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="not-pickup" v-model="filters.notPickup">
                                            <label class="custom-control-label" for="not-pickup">{{ $t('booking.filter.notPickup') }}</label>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="not-returns" v-model="filters.notReturns">
                                            <label class="custom-control-label" for="not-returns">{{ $t('booking.filter.notReturns') }}</label>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="not-drafts" v-model="filters.notDrafts">
                                            <label class="custom-control-label" for="not-drafts">{{ $t('booking.filter.notDrafts') }}</label>
                                        </div>
                                    </div>

                                    <div class="d-flex flex-row">
                                        <div>
                                            <label>{{ $t('booking.filter.fromDate') }}</label><br/>
                                            <date-picker :clearable="false" :lang="lang" v-model="filters.fromDate" format="DD-MM-YYYY" :editable="false"></date-picker>
                                        </div>
                                        <div class="pl-3">
                                            <label class="pl-4">{{ $t('booking.filter.toDate') }}</label><br/>

                                            <span class="pr-3">-</span>
                                            <date-picker :clearable="false" :lang="lang" v-model="filters.toDate" format="DD-MM-YYYY" :editable="false"></date-picker>
                                        </div>
                                    </div>

                                    <div class="form-group" v-if="$root.isAdmin">
                                        <label class="">{{ $t('booking.filter.customerNumber') }}</label>
                                        <multiselect
                                            v-model="filters.customerNumber"
                                            track-by="customerNumber"
                                            label="customerNumber"
                                            :options="customerNumbers"
                                            :placeholder="$t('booking.filter.customerNumber')"
                                            selectLabel=""
                                            selectedLabel=""
                                            deselectLabel=""
                                        >
                                            <template v-slot:noResult>
                                                {{ $t('third_party.multiselect.noResult') }}
                                            </template>
                                        </multiselect>
                                    </div>

                                    <div class="form-group">
                                        <label class="">{{ $t('booking.filter.recipient') }}</label>
                                        <multiselect
                                            v-model="filters.recipient"
                                            track-by="id"
                                            label="searchString"
                                            :options="recipients"
                                            :placeholder="$t('booking.filter.recipient')"
                                            selectLabel=""
                                            selectedLabel=""
                                            deselectLabel=""
                                        >
                                            <template slot="singleLabel" slot-scope="props">
                                                {{ props.option.name }}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                {{ props.option.name }}<br/>
                                                {{ props.option.address }}
                                                {{ props.option.address2 }}
                                                {{ props.option.postal_code }}
                                                {{ props.option.city }}
                                                {{ props.option.country }}
                                            </template>
                                            <template v-slot:noResult>
                                                {{ $t('third_party.multiselect.noResult') }}
                                            </template>
                                        </multiselect>
                                    </div>

                                    <div class="form-group">
                                        <label class="">{{ $t('booking.filter.sender') }}</label>
                                        <multiselect
                                            v-model="filters.sender"
                                            track-by="id"
                                            label="searchString"
                                            :options="senders"
                                            :placeholder="$t('booking.filter.sender')"
                                            selectLabel=""
                                            selectedLabel=""
                                            deselectLabel=""
                                        >
                                            <template slot="singleLabel" slot-scope="props">
                                                {{ props.option.name }}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                {{ props.option.name }}<br/>
                                                {{ props.option.address }}
                                                {{ props.option.postal_code }}
                                                {{ props.option.city }}
                                                {{ props.option.country }}
                                            </template>
                                            <template v-slot:noResult>
                                                {{ $t('third_party.multiselect.noResult') }}
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="form-group">
                                        <label class="">{{ $t('booking.filter.recipientCountry') }}</label>
                                        <multiselect
                                            v-model="filters.recipientCountry"
                                            track-by="code"
                                            :options="countryList"
                                            label="name"
                                            :placeholder="$t('booking.filter.recipientCountry')"
                                            selectLabel=""
                                            selectedLabel=""
                                            deselectLabel=""
                                        >
                                            <template slot="singleLabel" slot-scope="props">
                                                {{ props.option.name }}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                {{ props.option.name }}<br/>
                                            </template>
                                            <template v-slot:noResult>
                                                {{ $t('third_party.multiselect.noResult') }}
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="form-group">
                                        <label class="">{{ $t('tracking.trackingInfo') }}</label>
                                        <multiselect
                                            v-model="filters.trackingStatus"
                                            track-by="status"
                                            :options="trackingOptions"
                                            label="name"
                                            :placeholder="$t('tracking.trackingInfo')"
                                            selectLabel=""
                                            selectedLabel=""
                                            deselectLabel=""
                                            multiple
                                        >
                                            <template slot="singleLabel" slot-scope="props">
                                                {{ props.option.name }}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                {{ props.option.name }}<br/>
                                            </template>
                                            <template v-slot:noResult>
                                                {{ $t('third_party.multiselect.noResult') }}
                                            </template>
                                        </multiselect>
                                    </div>
                                    <button class="btn btn-primary float-right" @click="search">{{ $t('booking.filter.search') }}</button>
                                    <button class="btn btn-outline-danger float-right mr-4" @click="resetFilters">{{ $t('booking.filter.reset') }}</button>
                                </b-collapse>
                            </div>
                        </div>
                        <div>
                        <div class="row border-bottom border-secondary py-3 h6" v-if="bookings.length > 0">
                            <div class="col-1"></div>
                            <div class="col-1 text-center">{{ $t('booking.fields.created_at') }}</div>
                            <div class="col-1" v-if="$root.isAdmin">{{ $t('company.fields.lgt_customer_number') }}</div>
                            <div :class="{'col-3': !$root.isAdmin, 'col-2': $root.isAdmin}">{{ $t('booking.sender') }}</div>
                            <div class="col-3">{{ $t('booking.recipient') }}</div>
                            <div :class="{'col-1': $root.isAdmin, 'col-2': !$root.isAdmin}">{{ $t('booking.goodsUnits') }}</div>
                            <div class="col-1 text-center">{{ $t('tracking.trackingInfo') }}</div>
                            <div class="col-1 text-center" v-if="$root.isAdmin">
                                    {{ $t('booking.fields.exported_at') }}
                            </div>
                            <div class="col-1"></div>
                        </div>
                        <DynamicScroller
                            :items="bookings"
                            :min-item-size="54"
                            class="row"
                            pageMode
                        >
                            <template v-slot="{ item, index, active }">
                                <DynamicScrollerItem
                                    :item="item"
                                    :active="active"
                                    :size-dependencies="[
                                      item.company.name,
                                    ]"
                                    :data-index="index"
                                    class="col-12"
                                >
                                    <div class="row py-3 border-bottom border-secondary"
                                         :class="{
                                           'text-muted': checkCannotSelect(item),
                                           'bg-primary': highlightIds.includes(item.id),
                                          'text-white': highlightIds.includes(item.id) && !checkCannotSelect(item)
                                           }"
                                         :id="'booking-' + item.id"
                                        @click="goToBooking(item)">
                                        <div class="col-1 text-center">
                                            <div class="form-group mb-0 text-center">
                                                <div class="custom-control custom-checkbox"
                                                     @click.stop
                                                     v-if="item.is_return === false && item.hasPickup === false &&  item.delivered_by_sender === false && item.is_draft === false">
                                                    <input type="checkbox" class="custom-control-input" :id="'booking-check' + item.id" v-model="item.checked"
                                                           :disabled="checkCannotSelect(item)"
                                                           @click.self="pickupChecked(item)">
                                                    <label class="custom-control-label" :for="'booking-check' + item.id" @click.stop></label>
                                                </div>
                                            </div>
                                            <div class="badge badge-info" v-if="item.is_return">{{ $t('booking.returnBookingBadgeText') }}</div>
                                            <div class="badge badge-secondary" v-if="item.hasPickup">{{ $t('pickup.partOfPickup') }}</div>
                                            <div class="badge badge-warning" v-if="item.is_draft">{{ $t('booking.draftBadgeText') }}</div>
                                            <img v-if="item.hasLoadingList" src="/storage/loading-list.svg" height="15" style="margin-left: -9px; margin-top: 10px; opacity: 50%;" title="Har været med på en dannet læsseliste"/>
                                        </div>
                                        <div class="col-1 text-center">
                                            <span>{{ item.created_at.format('LLL') }}</span>
                                        </div>
                                        <div class="col-1" v-if="$root.isAdmin">
                                            {{ item.company.lgt_customer_number }}
                                        </div>
                                        <div :class="{'col-3': !$root.isAdmin, 'col-2': $root.isAdmin}">
                                            <p class="h5">{{ item.name }}</p>
                                            <p class="text-muted">{{ item.orderNumber }} <br /> {{ item.reference_number }}</p>
                                        </div>
                                        <div class="col-3">
                                            <p class="h5">{{ item.recipient.name }}, {{ item.recipient.country }}</p>
                                            <p class="text-muted">{{ item.recipient.reference_number }}</p>
                                        </div>
                                        <div :class="{'col-1': $root.isAdmin, 'col-2': !$root.isAdmin}">
                                            <table>
                                                <tr v-if="item.PLLCount > 0">
                                                    <td  class="border-0">{{ $t('pickup.sums.PLL') }}</td>
                                                    <td  class="border-0">{{ item.PLLCount }}</td>
                                                </tr>
                                                <tr v-if="item.KLLCount > 0">
                                                    <td  class="border-0">{{ $t('pickup.sums.KLL') }}</td>
                                                    <td  class="border-0">{{ item.KLLCount }}</td>
                                                </tr>
                                                <tr v-if="item.CBMCount > 0">
                                                    <td  class="border-0">{{ $t('pickup.sums.CMB') }}</td>
                                                    <td  class="border-0"> {{ new Intl.NumberFormat().format(item.CBMCount / 1000) }} </td>
                                                </tr>
                                                <tr v-if="item.loadingMeterCount > 0">
                                                    <td  class="border-0">{{ $t('pickup.sums.LDM') }}</td>
                                                    <td  class="border-0">{{ new Intl.NumberFormat().format(item.loadingMeterCount / 1000) }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="col-1 text-center">
                                            <tracking-badge :status="item.tracking_status_code" :date="item.tracking_date" :link="item.tracking_link" :shipment="item.shipment_id"></tracking-badge>
                                        </div>
                                        <div class="col-1 text-center" v-if="$root.isAdmin">
                                            <span :title="item.exported_at.format('LLL')" v-if="item.exported_at !== null">{{ item.exported_at.format('D MMMM') }}</span>
                                            <span v-else>{{ $t('core.no') }}</span>
                                        </div>
                                        <div class="col-1 text-right">
                                            <b-dropdown variant="link" right toggle-class="text-decoration-none py-0"
                                                        @show="dropdownShow"
                                                        @hide="dropdownHide"
                                                        class="float-right"
                                            >
                                                <template v-slot:button-content>
                                                    {{ $t('core.actions.more') }}
                                                </template>
                                                <b-dropdown-item :href="'/bookings/' + item.id" v-if="!item.is_draft">
                                                    {{ $t('core.actions.details') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item :href="'/bookings/' + item.id + '/edit'" v-if="item.is_draft">
                                                    {{ $t('core.actions.details') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item href="#" @click.prevent.stop="showLabelModalFn(item)">
                                                    {{ $t('booking.sendLabel') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item href="#" @click.prevent.stop="showInvoiceModalFn(item)" v-if="!item.is_draft">
                                                    {{ $t('booking.attachInvoice') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item v-if="item.hasPickup && !item.is_draft" :href="'/pickup/?highlight=' + item.pickupId">
                                                    {{ $t('booking.seePickup') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item :href="`/bookings/return/${item.id}`" v-if="item.is_return === false && !item.is_draft">
                                                    {{ $t('core.actions.bookReturnBooking') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item v-if="$root.isAdmin && !item.is_draft" href="#" @click.prevent.stop="resendBooking(item.id)">
                                                    {{ $t('core.actions.resendBooking') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item v-if="$root.isSuperAdmin || item.is_draft" href="#" @click.prevent.stop="deleteBooking(item.id)">
                                                    {{ $t('core.actions.deleteBooking') }}
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                    </div>
                                </DynamicScrollerItem>
                            </template>
                        </DynamicScroller>
                        <div class="text-center mt-4" v-if="filters.limitIds.length === 0 && bookings.length !== 0">
                        <button class="btn btn-primary" @click="loadMore">{{ $t('booking.loadMore') }}</button>
                        </div>
                        </div>
                        <div v-if="bookings.length === 0 && hasInitialBookings === false" class="text-center">
                            <h1>{{ $t('booking.emptyState') }}</h1>
                            <img src="/storage/empty-state.svg" height="200"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { BCollapse, BDropdown } from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/da'
import PickupModal from '@/Components/PickupModal'
import TrackingBadge from '@/Components/TrackingBadge'
import LabelModal from '@/Components/LabelModal'
import LoadingListModal from '@/components/LoadingListModal.vue'
import AttachInvoiceModal from '@/Components/AttachInvoiceToBookingModal'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import isEqual from 'lodash.isequal'

var VueScrollTo = require('vue-scrollto')

let emptyFilter = {
    query: '',
    recipient: null,
    sender: null,
    isNotExported: false,
    onlyReturns: false,
    onlyPickup: false,
    notPickup: false,
    notReturns: false,
    customerNumber: null,
    fromDate: null,
    trackingStatus: [],
    toDate: new Date(),
    recipientCountry: null,
    notDrafts: false,
    limitIds: []

}

export default {
    name: 'BookingIndex',
    components: { LabelModal, TrackingBadge, PickupModal, BCollapse, DatePicker, BDropdown, AttachInvoiceModal, DynamicScroller, DynamicScrollerItem, LoadingListModal },
    data: () => {
        return {
            showLoadingListModal: false,
            showLabelModal: false,
            showInvoiceModal: false,
            labelBooking: null,
            invoiceBooking: null,
            showPickupModal: false,
            pickupAddressComparer: '',
            filters: { ...emptyFilter },
            filterVisible: false,
            bookings: [],
            hasInitialBookings: false,
            recipients: lgt.recipients,
            senders: lgt.senders,
            customerNumbers: lgt.customerNumbers,
            lang: document.documentElement.lang.substr(0, 2),
            trackingOptions: [],
            highlightIds: [],
            countryList: [],
            nextPage: 1,
            searchActive: false
        }
    },
    computed: {
        checkedBookings () {
            return this.bookings.filter(x => x.checked)
        },
    },
    methods: {
        loadMore(){
            this.fetchBookings();
        },
        dropdownShow (e) {
            e.target.closest('.vue-recycle-scroller__item-view').style.zIndex = '1'
        },
        dropdownHide (e) {
            e.target.closest('.vue-recycle-scroller__item-view').style.zIndex = '0'
        },
        showLabelModalFn (booking) {
            this.labelBooking = booking
            this.showLabelModal = true
        },
        showInvoiceModalFn (booking) {
            this.invoiceBooking = booking
            this.showInvoiceModal = true
        },
        checkCannotSelect (booking) {
            return this.checkedBookings.length > 0 && (this.pickupAddressComparer !== booking.pickupAddressComparer)
        },
        pickupChecked (booking) {
            if (this.checkedBookings.length === 0) {
                this.pickupAddressComparer = booking.pickupAddressComparer
            }
        },
        search () {
            this.searchActive = true;
            this.saveFilter();
            this.fetchBookings(true);
        },
        resetFilters () {
            this.filters = { ...emptyFilter }
            this.searchActive = false;
            this.nextPage=2
            this.search()
        },
        parseBookings (bookings) {
            return bookings.map((item) => {
                item.created_at = moment.utc(item.created_at).tz(moment.tz.guess())
                item.exported_at = item.exported_at !== null ? moment.utc(item.exported_at).tz(moment.tz.guess()) : null
                item.checked = false
                item.modal = true
                item.hasLoadingList = item.loading_lists_count > 0
                return item
            })
        },
        resendBooking (bookingId) {
            axios.post('/bookings/' + bookingId + '/resend').then((response) => {
                window.location = '/bookings?success'
            })
        },
        deleteBooking (bookingId) {
            axios.delete('/bookings/' + bookingId).then((response) => {
                window.location = '/bookings?success'
            })
        },
        goToBooking (booking) {
            if(booking.is_draft){
                location.href = '/bookings/' + booking.id + '/edit'
            }else{
                location.href = '/bookings/' + booking.id
            }
        },
        saveFilter(){
            if(isEqual(this.filters, emptyFilter)){
                localStorage.removeItem('bookingIndexFilter');
            }else{
                localStorage.setItem('bookingIndexFilter', JSON.stringify(this.filters));
            }
        },
        fetchBookings(reset = false){
            if(reset){
                this.nextPage = 1;
            }
            let data = {page: this.nextPage};
            if(this.searchActive){
                data = {...data, ...{filterActive: true}, ...this.filters}
            }

            axios.post('/bookings/list', data).then((response) => {
                if(reset){
                    this.bookings = this.parseBookings(response.data.bookings)
                }else {
                    (this.parseBookings(response.data.bookings)).forEach((item) => {
                        this.bookings.push(item);
                    })
                }
                this.nextPage = response.data.nextPage;
            })
        },
        checkLimitIds(){
            const url = new URL(window.location)
            const params = new URLSearchParams(url.search)
            let highlightParam = params.get('highlight')
            if (highlightParam !== null) {
                this.searchActive = true;
                this.filters.limitIds = highlightParam.split(',').map(item => parseInt(item));
            }
        }
    },
    created () {
        Object.keys(this.$t('tracking.status')).forEach(key => {
            this.trackingOptions.push({
                status: key,
                name: this.$t('tracking.status.' + key),
            })
        })
        this.countryList = Object.entries(this.$t('countries')).map(([key, value]) => ({ code: key, name: value }))
    },
    mounted () {
        if(localStorage.bookingIndexFilter){
            try {
                const filterData = JSON.parse(localStorage.getItem('bookingIndexFilter'))
                this.filters = {...emptyFilter, ...filterData};
                this.filters.fromDate = filterData.fromDate === null ? null : new Date(filterData.fromDate);
                this.filters.toDate = filterData.toDate === null ? null : new Date(filterData.toDate);
                this.checkLimitIds();
                this.$nextTick(() => {
                    //Next tick is needed for the collapse to not hide the filter on mounted
                    this.filterVisible = true;
                })
                this.search();
            } catch(e) {
                localStorage.removeItem('bookingIndexFilter');
                this.checkLimitIds();
                this.fetchBookings(true);
            }
        }else {
            this.checkLimitIds();
            this.fetchBookings(true);
        }
    },
}
</script>
